const common = {
  namespaced: true,
  state: {
    platformPath:'',//建营一体过来的路由
    isPlatform:false,//是否建营一体
    userInfo: {},
    menuIDs: [],
    clickTime:null
  },
  mutations: {
    getUserInfo(state, users) {
      state.userInfo = users
    },
    getMenuIDs(state, ids) {
      state.menuIDs = ids
    },
    getClickTime(state, ids) {
      state.clickTime = ids
    },
    //建营一体过来的路由
    setPlatformPath (state, val) {
      state.platformPath = val
    },
    setIsPlatform (state, val) {
      state.isPlatform = val
    },
  },
}
export default common
